var PromiseStates;
(function (PromiseStates) {
    PromiseStates[PromiseStates["Pending"] = 0] = "Pending";
    PromiseStates[PromiseStates["Fulfilled"] = 1] = "Fulfilled";
    PromiseStates[PromiseStates["Rejected"] = 2] = "Rejected";
})(PromiseStates || (PromiseStates = {}));
var FulFillmentAgregator = /** @class */ (function () {
    function FulFillmentAgregator() {
        this.count = 0;
        this.target = 0;
        this.results = [];
    }
    return FulFillmentAgregator;
}());
var InternalPromise = /** @class */ (function () {
    function InternalPromise(resolver) {
        var _this = this;
        this._state = PromiseStates.Pending;
        this._children = new Array();
        this._rejectWasConsumed = false;
        if (!resolver) {
            return;
        }
        try {
            resolver(function (value) {
                _this._resolve(value);
            }, function (reason) {
                _this._reject(reason);
            });
        }
        catch (e) {
            this._reject(e);
        }
    }
    Object.defineProperty(InternalPromise.prototype, "_result", {
        get: function () {
            return this._resultValue;
        },
        set: function (value) {
            this._resultValue = value;
            if (this._parent && this._parent._result === undefined) {
                this._parent._result = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    InternalPromise.prototype.catch = function (onRejected) {
        return this.then(undefined, onRejected);
    };
    InternalPromise.prototype.then = function (onFulfilled, onRejected) {
        var _this = this;
        var newPromise = new InternalPromise();
        newPromise._onFulfilled = onFulfilled;
        newPromise._onRejected = onRejected;
        // Composition
        this._children.push(newPromise);
        newPromise._parent = this;
        if (this._state !== PromiseStates.Pending) {
            setTimeout(function () {
                if (_this._state === PromiseStates.Fulfilled || _this._rejectWasConsumed) {
                    var returnedValue = newPromise._resolve(_this._result);
                    if (returnedValue !== undefined && returnedValue !== null) {
                        if (returnedValue._state !== undefined) {
                            var returnedPromise = returnedValue;
                            newPromise._children.push(returnedPromise);
                            returnedPromise._parent = newPromise;
                            newPromise = returnedPromise;
                        }
                        else {
                            newPromise._result = returnedValue;
                        }
                    }
                }
                else {
                    newPromise._reject(_this._reason);
                }
            });
        }
        return newPromise;
    };
    InternalPromise.prototype._moveChildren = function (children) {
        var _a;
        var _this = this;
        (_a = this._children).push.apply(_a, children.splice(0, children.length));
        this._children.forEach(function (child) {
            child._parent = _this;
        });
        if (this._state === PromiseStates.Fulfilled) {
            for (var _i = 0, _b = this._children; _i < _b.length; _i++) {
                var child = _b[_i];
                child._resolve(this._result);
            }
        }
        else if (this._state === PromiseStates.Rejected) {
            for (var _c = 0, _d = this._children; _c < _d.length; _c++) {
                var child = _d[_c];
                child._reject(this._reason);
            }
        }
    };
    InternalPromise.prototype._resolve = function (value) {
        try {
            this._state = PromiseStates.Fulfilled;
            var returnedValue = null;
            if (this._onFulfilled) {
                returnedValue = this._onFulfilled(value);
            }
            if (returnedValue !== undefined && returnedValue !== null) {
                if (returnedValue._state !== undefined) {
                    // Transmit children
                    var returnedPromise = returnedValue;
                    returnedPromise._parent = this;
                    returnedPromise._moveChildren(this._children);
                    value = returnedPromise._result;
                }
                else {
                    value = returnedValue;
                }
            }
            this._result = value;
            for (var _i = 0, _a = this._children; _i < _a.length; _i++) {
                var child = _a[_i];
                child._resolve(value);
            }
            this._children.length = 0;
            delete this._onFulfilled;
            delete this._onRejected;
        }
        catch (e) {
            this._reject(e, true);
        }
    };
    InternalPromise.prototype._reject = function (reason, onLocalThrow) {
        if (onLocalThrow === void 0) { onLocalThrow = false; }
        this._state = PromiseStates.Rejected;
        this._reason = reason;
        if (this._onRejected && !onLocalThrow) {
            try {
                this._onRejected(reason);
                this._rejectWasConsumed = true;
            }
            catch (e) {
                reason = e;
            }
        }
        for (var _i = 0, _a = this._children; _i < _a.length; _i++) {
            var child = _a[_i];
            if (this._rejectWasConsumed) {
                child._resolve(null);
            }
            else {
                child._reject(reason);
            }
        }
        this._children.length = 0;
        delete this._onFulfilled;
        delete this._onRejected;
    };
    InternalPromise.resolve = function (value) {
        var newPromise = new InternalPromise();
        newPromise._resolve(value);
        return newPromise;
    };
    InternalPromise._RegisterForFulfillment = function (promise, agregator, index) {
        promise.then(function (value) {
            agregator.results[index] = value;
            agregator.count++;
            if (agregator.count === agregator.target) {
                agregator.rootPromise._resolve(agregator.results);
            }
            return null;
        }, function (reason) {
            if (agregator.rootPromise._state !== PromiseStates.Rejected) {
                agregator.rootPromise._reject(reason);
            }
        });
    };
    InternalPromise.all = function (promises) {
        var newPromise = new InternalPromise();
        var agregator = new FulFillmentAgregator();
        agregator.target = promises.length;
        agregator.rootPromise = newPromise;
        if (promises.length) {
            for (var index = 0; index < promises.length; index++) {
                InternalPromise._RegisterForFulfillment(promises[index], agregator, index);
            }
        }
        else {
            newPromise._resolve([]);
        }
        return newPromise;
    };
    InternalPromise.race = function (promises) {
        var newPromise = new InternalPromise();
        if (promises.length) {
            for (var _i = 0, promises_1 = promises; _i < promises_1.length; _i++) {
                var promise = promises_1[_i];
                promise.then(function (value) {
                    if (newPromise) {
                        newPromise._resolve(value);
                        newPromise = null;
                    }
                    return null;
                }, function (reason) {
                    if (newPromise) {
                        newPromise._reject(reason);
                        newPromise = null;
                    }
                });
            }
        }
        return newPromise;
    };
    return InternalPromise;
}());
/**
 * Helper class that provides a small promise polyfill
 */
var PromisePolyfill = /** @class */ (function () {
    function PromisePolyfill() {
    }
    /**
     * Static function used to check if the polyfill is required
     * If this is the case then the function will inject the polyfill to window.Promise
     * @param force defines a boolean used to force the injection (mostly for testing purposes)
     */
    PromisePolyfill.Apply = function (force) {
        if (force === void 0) { force = false; }
        if (force || typeof Promise === 'undefined') {
            var root = window;
            root.Promise = InternalPromise;
        }
    };
    return PromisePolyfill;
}());
export { PromisePolyfill };
//# sourceMappingURL=promise.js.map